export class SchemaRegistryConnectResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "serverVersion",
            "baseName": "serverVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "latencyMs",
            "baseName": "latencyMs",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryConnectResponse.attributeTypeMap;
    }
    constructor() {
    }
}
